var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreHorizontalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7858C12.5523 13.7858 13 13.3381 13 12.7858C13 12.2335 12.5523 11.7858 12 11.7858C11.4477 11.7858 11 12.2335 11 12.7858C11 13.3381 11.4477 13.7858 12 13.7858Z",
    stroke: "#868693",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.7858C19.5523 13.7858 20 13.3381 20 12.7858C20 12.2335 19.5523 11.7858 19 11.7858C18.4477 11.7858 18 12.2335 18 12.7858C18 13.3381 18.4477 13.7858 19 13.7858Z",
    stroke: "#868693",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.7858C5.55228 13.7858 6 13.3381 6 12.7858C6 12.2335 5.55228 11.7858 5 11.7858C4.44772 11.7858 4 12.2335 4 12.7858C4 13.3381 4.44772 13.7858 5 13.7858Z",
    stroke: "#868693",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontalIcon);
export default __webpack_public_path__ + "static/media/more-horizontal-icon.5f85ed08ad960d140c1f471df9435e48.svg";
export { ForwardRef as ReactComponent };